import * as Sentry from '@sentry/vue'
import { getReleaseString } from '../src/constants'
import { useAuthStore } from '../stores/authStore'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const vueApp = nuxtApp.vueApp
  const router = useRouter()

  const authStore = useAuthStore()
  
  // Only initialize if SENTRY_DSN is configured
  if (config.public.sentryDsn) {
    console.log("Sentry: initializing with environment:", config.public.sentryEnvironment)
    Sentry.init({
      app: vueApp,
      dsn: config.public.sentryDsn,
      // release: process.env.SENTRY_RELEASE || new Date().toISOString(),
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
      ],
      
      // Tracing configuration
      tracesSampleRate: (() => {
        switch (config.public.sentryEnvironment) {
          case 'development': return 1.0
          case 'staging': return 1.0
          case 'production': return 1.0
        //   case 'staging': return 0.5
        //   case 'production': return 0.1
          default: return 0.1
        }
      })(),
      
      // Session Replay configuration
      replaysSessionSampleRate: (() => {
        switch (config.public.sentryEnvironment) {
          case 'development': return 1.0
          case 'staging': return 1.0
          case 'production': return 1.0
        //   case 'staging': return 0.5
        //   case 'production': return 0.1
          default: return 0.1
        }
      })(),
      
      // Environment configuration
      environment: config.public.sentryEnvironment,
      
      // Release tracking (optional, but recommended)
      release: getReleaseString(config.public.sentryEnvironment),
      
      // Enable debug only in development
      debug: config.public.sentryEnvironment === 'development',
      
      // Enable in staging and production
      enabled: config.public.sentryEnvironment !== 'development',

      // Customize error filtering
      beforeSend(event) {
        let theUserId: string | undefined = undefined
        // let theUserEmail: string | undefined = undefined  
        try {
          if (authStore.userLoggedIn) {
            theUserId = authStore.userId
            // console.log("Sentry: userLoggedIn, userId:", theUserId)
          } 
        } catch (error) {}
          
        if (theUserId) {
          // Set user context for the event
          event.user = {
            id: theUserId,      
            // email: theUserEmail, // Optional: include if you want to track email
          }
        }

        // Don't send errors in development
        if (config.public.sentryEnvironment === 'development') {
          return null
        }
        
        // Filter out specific errors if needed
        // if (event.exception?.values?.[0]?.type === 'NetworkError') {
        //   // Optionally handle network errors differently
        //   event.fingerprint = ['network-error']
        // }
        
        return event
      }
    })
  }
}) 